// Include the USWDS Accordion script.
// This makes the component available globally. If you're only using it on certain pages,
// include it on a template-specific script file instead.
// Be sure to initialize any components as well (see init() function below.)
import accordion from '@uswds/uswds/js/usa-accordion';
import banner from '@uswds/uswds/js/usa-banner';
import comboBox from '@uswds/uswds/js/usa-combo-box';
import datePicker from '@uswds/uswds/js/usa-date-picker';
import timePicker from '@uswds/uswds/js/usa-time-picker';
import fileInput from '@uswds/uswds/js/usa-file-input';
import modal from '@uswds/uswds/js/usa-modal';
import search from '@uswds/uswds/js/usa-search';
import tooltip from '@uswds/uswds/js/usa-tooltip';
import skipnav from '@uswds/uswds/js/usa-skipnav';
import table from '@uswds/uswds/js/usa-table';
import validation from '@uswds/uswds/js/usa-validation';
import header from '@uswds/uswds/js/usa-header';
import footer from '@uswds/uswds/js/usa-footer';
import inPageNav from '@uswds/uswds/js/usa-in-page-navigation';
import languageSelector from '@uswds/uswds/js/usa-language-selector';
import Drupal from 'drupal';

Drupal.behaviors.uswds = {
  attach(context) {
    const initialElem = context === document ? document.body : context;;
    accordion.on(initialElem);
    banner.on(initialElem);
    tooltip.on(initialElem);
    comboBox.on(initialElem);
    datePicker.on(initialElem);
    timePicker.on(initialElem);
    modal.on(initialElem);
    skipnav.on(initialElem);
    search.on(initialElem);
    validation.on(initialElem);
    fileInput.on(initialElem);
    table.on(document.body);
    header.on(document.body);
    footer.on(initialElem);
    inPageNav.on(initialElem);
    languageSelector.on(initialElem);
    window.uswdsPresent = true;
  }
};


